import { connect } from "react-redux";
import VendorRequest from "./vendorRequest";
import { bindActionCreators } from "redux";
import { getVendorRequestSubmit,getDepartment } from "services/redux/sales/vendorPortal/action";

import {
  fetchZones,
} from "services/redux/sales/preSaleListing/action";

const mapStateToProps = (state) => ({
  getFetchZones: state.preSalesListReducer.getFetchZones,
  vendorDepartment: state.vendorPortalReducer.vendorDepartment,
 
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchZones,
      getVendorRequestSubmit,
      getDepartment,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(VendorRequest);
